import { render, staticRenderFns } from "./COptionsProjectModal.vue?vue&type=template&id=b4b50ea4&scoped=true&"
import script from "./COptionsProjectModal.vue?vue&type=script&lang=js&"
export * from "./COptionsProjectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b50ea4",
  null
  
)

export default component.exports